import { render, staticRenderFns } from "./FinalizarSimples.vue?vue&type=template&id=68f5876e&scoped=true"
import script from "./FinalizarSimples.vue?vue&type=script&lang=js"
export * from "./FinalizarSimples.vue?vue&type=script&lang=js"
import style0 from "./FinalizarSimples.vue?vue&type=style&index=0&id=68f5876e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5876e",
  null
  
)

export default component.exports